import { Col, ListGroup, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

import Message from "./Message";

import { AppState } from "../redux/types";
import { SHIPPING_METHODS } from "../utils/constants";
import { displayPrice, formatAmountWithCurrency, getOrderCurrencySymbolFromCountry } from "../utils/currency";

const OrderInfo = () => {
    const user = useSelector((state: AppState) => state.user);
    const { list } = useSelector((state: AppState) => state.seniorHomes);
    const { firstName, lastName, orders } = user;
    const VCA_sub_status = useSelector((state: AppState) => state.subscription.get?.subscriptionData?.status);
    const trialCurrencySymbol = getOrderCurrencySymbolFromCountry("fi");

    // console.log(orders)

    return (
        <>
            {/* <h5 className='order-header'>Tilaustiedot</h5> */}
            {/* TODO: fix */}
            {!orders ? (
                <Message>Sinulla ei ole voimassaolevaa tilausta</Message>
            ) : (
                <ListGroup
                    variant="flush"
                    style={{
                        fontFamily: "'Poppins', sans-serif",
                        color: "#35413e",
                        padding: "0 15px",
                    }}
                >
                    {orders
                        .sort((a, b) => b.id - a.id)
                        .map((order: any, index) => {
                            const currencySymbol = getOrderCurrencySymbolFromCountry(order?.country);
                            return (
                                <div
                                key={`${order.id}_${index}`}
                                style={
                                    {
                                        // border: '2px solid rgba(0,0,0,.125)'
                                    }
                                }
                            >
                                <ListGroup.Item style={{ border: "none" }}>
                                    <h2 className="order-headers">Toimitusosoite</h2>
                                    <Row key={`order_number_${order.id}`}>
                                        <Col xs={8} sm={9}>
                                            <p className="">Tilausnumero</p>
                                        </Col>
                                        <Col xs={4} sm={3}>
                                            <p style={{ textAlign: "right" }} className="notranslate" translate="no">#{order.id}</p>
                                        </Col>
                                    </Row>
                                    <p className="customer-name notranslate" translate="no">
                                        {firstName} {lastName}
                                    </p>
                                    {order.shippingMethod === SHIPPING_METHODS.direct && "Toimitus seniorille kotisairaanhoitoon, palveluasuntoon tai yhteistyöhoivakotiin"}
                                    {(order.shippingMethod === SHIPPING_METHODS.posti || order.shippingMethod === SHIPPING_METHODS.posti_gadgets) && "Toimitus asiakkaalle Postin noutopisteeseen"}
                                    {(order.shippingMethod === SHIPPING_METHODS.posti || order.shippingMethod === SHIPPING_METHODS.posti_gadgets) && (
                                        <p className="order-texts notranslate" translate="no">
                                            Osoite: {order.address}, {order.postalCode}, {order.city}
                                        </p>
                                    )}
                                    {(order.shippingMethod === SHIPPING_METHODS.posti || order.shippingMethod === SHIPPING_METHODS.posti_gadgets) && order.usePickupPoint && (
                                        <div className="notranslate" translate="no">{`${order.pickupPointData?.name} (${order.pickupPointData?.address1}, ${order.pickupPointData?.city})`}</div>
                                    )}
                                    {order.shippingMethod === SHIPPING_METHODS.direct && <p className="order-texts notranslate" translate="no">Toimituskohde: {list.find((el) => el.reference === order.nursingHome)?.name}</p>}
                                    {/*{order.isDelivered ? (*/}
                                    {/*  <Message variant='success'>*/}
                                    {/*    Toimitettu {order.deliveredAt}*/}
                                    {/*  </Message>*/}
                                    {/*) : (*/}
                                    {/*  <Message variant='danger'>Toimittamatta</Message>*/}
                                    {/*)}*/}
                                </ListGroup.Item>

                                <ListGroup.Item style={{ border: "none" }}>
                                    <h2 className="order-headers">Maksu</h2>
                                    <div className="order-texts">
                                        Maksutapa: {order.paymentMethod === "card" && "Kortti"}
                                        {order.paymentMethod === "email_billing" && "Sähköpostilasku"}
                                        {order.paymentMethod === "contract_billing" && "Laskutussopimus kotisairaanhoidon, hoivakodin tai palveluasunnon kautta"}
                                    </div>
                                    {/*{order.isPaid ? (*/}
                                    {/*  <Message variant='success'>Maksettu {order.paidAt}</Message>*/}
                                    {/*) : (*/}
                                    {/*  <Message variant='danger'>Maksamatta</Message>*/}
                                    {/*)}*/}
                                </ListGroup.Item>

                                <ListGroup.Item style={{ border: "none" }}>
                                    <h2 className="placeorder-headers">Palvelu</h2>
                                    {order.services.map((item: any, index: any) => (
                                        <Row key={index}>
                                            <Col xs={8} sm={9}>
                                                <p className="">
                                                    {item.name}
                                                    {order.coupon && (
                                                        <div className="selected-product notranslate" translate="no">
                                                            <small>
                                                                <em>Maksuton kokeilujakso: {order.coupon}</em>
                                                            </small>
                                                        </div>
                                                    )}
                                                </p>
                                            </Col>
                                            <Col xs={4} sm={3}>
                                                <p className="selected-product-price notranslate" translate="no">{displayPrice(item, currencySymbol)}</p>
                                            </Col>
                                        </Row>
                                    ))}
                                    <Row>
                                        <Col xs={8} sm={9}>
                                            Toimitusmaksu
                                        </Col>
                                        <Col xs={4} sm={3}>
                                            <p className="selected-product-price notranslate" translate="no">
                                                {formatAmountWithCurrency(order.shippingPrice, currencySymbol)}
                                            </p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={8} sm={9}>
                                            <p className="selected-product">Loppusumma</p>
                                        </Col>
                                        <Col xs={4} sm={3}>
                                            <p className="selected-product selected-product-price notranslate" translate="no">{formatAmountWithCurrency(order.totalPrice, currencySymbol)}</p>
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                            </div>
                            );
                        })}

                    {VCA_sub_status && (
                        <>
                            {VCA_sub_status === "trialing" && (
                                <ListGroup.Item style={{ border: "none" }}>
                                    <h2 className="order-headers" style={{ color: "var(--text-primary)", fontWeight: "600" }}>
                                        Palvelu
                                    </h2>
                                    <Row key={`order_number_trail_video_call_app`}>
                                        <Col xs={8} sm={9}>
                                            <p>Tilausnumero</p>
                                        </Col>
                                        <Col xs={4} sm={3}>
                                            <p style={{ textAlign: "right" }}># # # #</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={8} sm={8}>
                                            <p className="customer-name">Digihappy appi</p>
                                        </Col>
                                        <Col xs={4} sm={4}>
                                            <div style={{ textAlign: "right" }}>
                                                <span>{formatAmountWithCurrency(0, trialCurrencySymbol)}</span>
                                                <br />
                                                <span>2 viikon jälkeen {formatAmountWithCurrency("9,50", trialCurrencySymbol)}/kk</span>
                                            </div>
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                            )}
                            <ListGroup.Item style={{ border: "none" }}>
                                <h2 style={{ color: "var(--text-primary)", fontWeight: "600" }}>Seuraavaksi</h2>
                                <div style={{ marginBottom: "1em", color: "var(--text-primary)" }}>
                                    <ol>
                                        <li>
                                            Lataa puhelimellesi Digihappy appi ja kirjaudu sisään <em>omilla</em> tunnuksillasi.
                                        </li>
                                        <li>
                                            Lataa Digihappy appi seniorin tabletille ja kirjaudu sisään <em>seniorin</em> tunnuksilla, jotka saat sähköpostiisi! Säädä oikeat asetukset. Katso sähköpostin liitteenä oleva ohje.
                                        </li>
                                        <li>Läheiset lataavat omille puhelimille Digihappy apin ja kirjautuvat sisään omilla tunnuksilla, jotka he saavat sähköpostitse.</li>
                                        <li>
                                            <strong>Saat 2 viikon kuluttua maksulinkin sähköpostitse.</strong> Jos et maksa kuukausimaksua, palvelu poistuu käytöstäsi.
                                        </li>
                                    </ol>
                                </div>
                            </ListGroup.Item>
                        </>
                    )}
                </ListGroup>
            )}
        </>
    );
};

export default OrderInfo;
